export const generalApiSettings = {
  authenticationScheme: process.env.REACT_APP_API_AUTHENTICATION_SCHEME
};

export const mainApi = {
  name: "mainApi",
  url: process.env.REACT_APP_MAIN_API_URL
};

export const cacheApi = {
  name: "cacheApi",
  url: process.env.REACT_APP_CACHE_API_URL
};
